import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { colors } from '../Theme/WebTheme';

const LoadingProgress = ({ open, message = 'Loading...' }) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          bgcolor={colors.WHITE}
          p={3}
          borderRadius={2}
        >
          <CircularProgress 
            size={48} 
            sx={{ color: colors.MAIN_COLOR }}
          />
          {message && (
            <Typography
              variant="body1"
              style={{ marginTop: 16, textAlign: 'center' }}
            >
              {message}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingProgress;
